export const aggregateItemKey = (qIdx, itemIdx) => `q${qIdx}_item${itemIdx}`;
export const parseAggregateAnswer = (answer) => {
    if (!answer)
        return {};
    try {
        const parsed = JSON.parse(answer);
        return typeof parsed === 'object' && parsed !== null ? parsed : {};
    }
    catch {
        return {};
    }
};
export const aggregateItemValue = (raw, inputType) => {
    if (raw === undefined || raw === null || raw === '')
        return '';
    if (inputType !== 'number')
        return String(raw);
    const num = Number(raw);
    return Number.isFinite(num) ? num : String(raw);
};
